module.exports = __webpack_public_path__ + "img/rent-normal-mobile.2c2ba3b4.jpeg";